import { AppleIcon, LinuxIcon, WindowsIcon } from "./PlatformIcons";

interface GamePlatformsProps {
  supportsWindows: boolean | null;
  supportsMac: boolean | null;
  supportsLinux: boolean | null;
  className?: string;
}

export function GamePlatforms({
  supportsWindows,
  supportsMac,
  supportsLinux,
  className = "",
}: GamePlatformsProps) {
  return (
    <div className={`flex gap-1.5 text-[#8f98a0] ${className}`}>
      {supportsWindows && (
        <span title="Windows">
          <WindowsIcon />
        </span>
      )}
      {supportsMac && (
        <span title="Mac">
          <AppleIcon />
        </span>
      )}
      {supportsLinux && (
        <span title="Linux">
          <LinuxIcon />
        </span>
      )}
    </div>
  );
}

